import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import GridTable from "pages/_components/GridTable/GridTable";
import { bool, number, shape, string } from "prop-types";
import InfoTag from "pages/echeck/components/InfoTag";
import { statusTagColor } from "util/thirdPayment";
import * as i18n from "util/i18n";
import React from "react";
import CustomData from "pages/_components/CustomData/CustomData";

const MassiveEcheckRow = ({ echeqItem, debitAccount, fromTransactionPage, transactionStatus }) => {
    let quantity = echeqItem.creditAmountQuantity;
    let fechaFormat = echeqItem.echeqPayDay;

    const getStatus = (status) => {
        switch (status) {
            case "PENDING":
                return "Pendiente";
            case "PROCESSING":
                return "Procesando";
            case "PROCESSED":
                return "Procesado";
            case "PROCESSED_WITH_ERROR":
                return "Procesado con error";
            default:
                return "";
        }
    };

    if (typeof echeqItem.creditAmountQuantity === "string" || echeqItem.creditAmountQuantity instanceof String) {
        quantity = parseFloat(echeqItem.creditAmountQuantity.replace(",", "."));
    }

    try {
        fechaFormat = echeqItem.echeqPayDay;

        // pendiente y procesando
        if (echeqItem.echeqPayDay.length === 8) {
            const ano = echeqItem.echeqPayDay.substring(0, 4);
            const mes = echeqItem.echeqPayDay.substring(4, 6);
            const dia = echeqItem.echeqPayDay.substring(6, 8);
            fechaFormat = `${ano}/${mes}/${dia}`;
        }

        // finalizado y fallido
        if (echeqItem.echeqPayDay.includes("-")) {
            fechaFormat = echeqItem.echeqPayDay.replaceAll("-", "/");
        }
    } catch (e) {
        fechaFormat = echeqItem.echeqPayDay;
    }

    return (
        <>
            <GridTable.Data columnStart={1} rowStart={1}>
                <CustomData
                    titleText="massiveEcheck.table.issueNumber"
                    titleTextType="I18N"
                    valueText={echeqItem.lineNumber}
                />
            </GridTable.Data>
            <GridTable.Data columnStart={2} rowStart={1}>
                <CustomData titleText="massiveEcheck.table.date" titleTextType="I18N" valueText={fechaFormat} />
            </GridTable.Data>
            <GridTable.Data columnStart={3} rowStart={1}>
                <CustomData
                    titleText="massiveEcheck.table.cuit"
                    titleTextType="I18N"
                    valueText={echeqItem.beneficiaryDocumentNumber}
                />
            </GridTable.Data>
            <GridTable.Data columnStart={4} rowStart={1}>
                <CustomData
                    titleText="massiveEcheck.table.transmitter"
                    titleTextType="I18N"
                    valueText={echeqItem.beneficiaryName}
                />
            </GridTable.Data>
            <GridTable.Data columnStart={5} rowStart={1}>
                {echeqItem?.status ? (
                    <InfoTag
                        type="info"
                        message={getStatus(echeqItem?.status)}
                        tagBackground={statusTagColor(echeqItem?.status)}
                    />
                ) : (
                    <CustomText text={i18n.get("massiveEcheck.table.state")} textType="TEXT" />
                )}
            </GridTable.Data>
            <GridTable.Data columnStart={6} rowStart={1}>
                <CustomData titleText="echecks.emit.motive.label" titleTextType="I18N" valueText={echeqItem.motive} />
            </GridTable.Data>
            <GridTable.Data columnStart={7} rowStart={1}>
                <CustomData
                    titleText="lotPayment.new.amount"
                    titleTextType="I18N"
                    valueText={<FormattedAmount quantity={quantity} currency="ARS" showAbbreviature={false} />}
                />
            </GridTable.Data>
        </>
    );
};

MassiveEcheckRow.propTypes = {
    echeqItem: shape({
        account: string,
        cbu: string,
        cuit: string,
        creditAmountQuantity: string,
        voucher: string,
        motivo: string,
        referenc: string,
        nameEmit: string,
        lineNumber: number,
        cuitEmit: string,
    }).isRequired,
    debitAccount: string.isRequired,
    fromTransactionPage: bool,
    transactionStatus: string.isRequired,
};

MassiveEcheckRow.defaultProps = {
    fromTransactionPage: false,
};

export default MassiveEcheckRow;
